import { BREADCRUMB_TYPE } from '../../components/Atoms/BreadCrumb';

export const MOBILE_BREAKPOINT = 768;

export const CASH_FLOW = {
  title: 'What is a cash flow statement?',
  text1:
    'It is a financial statement that offers aggregate statistics on all cash inflows a business collects from its continuing activities and external sources of investment. It also includes all cash outflows over a specified time paying for company operations and investments.',
  text2:
    'The main components of the CFS are cash from three areas: operating, investing, and financing activities...',
  readMoreUrl: 'https://cleartax.in/g/terms/cash-flow-statement',
  pictureUrl:
    'https://assets1.cleartax-cdn.com/cleartax/images/1644910687_cash_flow.png',
};
export const DIVIDENDS = {
  title: 'What are dividends?',
  text1:
    'Dividend, in financial terms, means a certain amount shared with shareholders of a company or a mutual fund on a regular basis – monthly, quarterly or annually.',
  readMoreUrl: 'https://cleartax.in/s/dividends',
  pictureUrl:
    'https://assets1.cleartax-cdn.com/cleartax/images/1645177286_dividendimg.png',
};

export const BONUSES = {
  title: 'What are bonuses?',
  text1:
    'A bonus issue is an offer given to the existing shareholders of the company to subscribe for additional shares. Instead of increasing the dividend payout, the companies off...',
  readMoreUrl: 'https://cleartax.in/g/terms/bonus-issue',
  pictureUrl:
    'https://assets1.cleartax-cdn.com/cleartax/images/1645177265_bonusimg.png',
};

export const BALANCE_SHEET = {
  title: 'What is a balance sheet?',
  readMoreUrl: 'https://cleartax.in/g/terms/balance-sheet',
  pictureUrl:
    'https://assets1.cleartax-cdn.com/cleartax/images/1644919025_balancesheet.png',
  text1:
    'A balance sheet is a financial statement that records the assets, liabilities, and equity of a company at a certain point in time and provides a basis for estimating return rates and determining the capital structure. It offers a snapshot of what an entity owns and owes, as well as the sum that shareholders spend.',
  text2: `The balance sheet complies with the following accounting equation in which assets on the one side, and liabilities plus shareholders' equity on the other, balance out:`,
  text3:
    'This is used to conduct fundamental analysis or the estimation of financial ratios alongside other essential financial statements, such as income statement and statement of cash flows...',
};
export type keyRatioPlaceHolderMappingType = Array<{
  key: string;
  placeholder: string;
  tooltipTitle: string;
  tooltipDescription: string;
}>;

export const keyRatioPlaceHolderMapping = [
  {
    key: 'pe_ratio',
    placeholder: 'PE TTM',
    tooltipTitle: 'Price-To- Earning Trailing twelve months',
    tooltipDescription: `The price/earnings ratio is often referred to as P/E (TTM) and is calculated as the stock's 
    current price, divided by a company's trailing 12-month earnings per share (EPS).`,
  },
  {
    key: 'pb_ratio',
    placeholder: 'P/B',
    tooltipTitle: 'Price-to-Book Ratio',
    tooltipDescription: `Companies use the price-to-book ratio (P/B ratio) to compare a firm's market capitalization
    to its book value. It's calculated by dividing the company's stock price per share by its book 
   value per share (BVPS). `,
  },
  {
    key: 'roe',
    placeholder: 'ROE',
    tooltipTitle: 'Return on Equity',
    tooltipDescription: `Return on equity (ROE) is a measure of financial performance calculated by dividing net 
    income by shareholders' equity.`,
  },
  {
    key: 'roce',
    placeholder: 'ROCE',
    tooltipTitle: 'Return on Capital Employed',
    tooltipDescription: `Return on capital employed (ROCE) is a financial ratio that can be used to assess a 
    company's profitability and capital efficiency.`,
  },
  {
    key: 'dividend_yield',
    placeholder: 'Dividend yield',
    tooltipTitle: 'Dividend yield',
    tooltipDescription: `The dividend yield—displayed as a percentage—is the amount of money a company pays 
    shareholders for owning a share of its stock divided by its current stock price.`,
  },
  {
    key: 'eps',
    placeholder: 'EPS TTM',
    tooltipTitle: 'Earning per Share Trailing twelve months',
    tooltipDescription:
      'EPS (TTM) is the total earnings or profits the company has made over the last 12 months.',
  },
  {
    key: 'ebitda_growth',
    placeholder: 'EBTIDA Growth',
    tooltipTitle:
      'Earnings Before Interest, Taxes, Depreciation, and Amortization',
    tooltipDescription: `
    EBITDA Growth means the percentage increase (if any) in EBITDA for any Year, 
    as compared to the previous Year as determined from time to time by the Committee.`,
  },
  {
    key: 'debt_to_equity',
    placeholder: 'D/E',
    tooltipTitle: 'Debt-to-Equity Ratio',
    tooltipDescription: `The debt-to-equity (D/E) ratio is used to evaluate a company's financial leverage and is 
    calculated by dividing a company’s total liabilities by its shareholder equity.`,
  },
  {
    key: 'sector_pe',
    placeholder: 'Sector PE',
    tooltipTitle: 'Average price-to-earning ratio of a particular sector ',
    tooltipDescription: `Sector PE is the average price-to-earning ratio of a particular sector or industry. It's used as a benchmark to compare the PE of a stock to the PE of an entire industry.`,
  },
  {
    key: 'bookvalue',
    placeholder: 'BV',
    tooltipTitle: 'Book Value',
    tooltipDescription: `Book value is the net value of a firm's assets found on its balance sheet, and it is roughly equal to the total amount all shareholders would get if they liquidated the company.`,
  },
];

export type keyPlaceHolderMappingType = Array<{
  key: string;
  placeholder: string;
  tooltip: string;
  pictureUrl: string;
}>;

export const keyPlaceHolderMapping = [
  {
    key: 'hi_52_wk',
    placeholder: '52w high/low',
    pictureUrl:
      'https://assets1.cleartax-cdn.com/cleartax/images/1645010283_low.svg',
    tooltip:
      'The 52-week high/low is the highest and lowest price at which a security, such as a stock, has traded during the time period that equates to one year.',
  },
  {
    key: 'pe_ratio',
    placeholder: 'P/E ratio',
    pictureUrl:
      'https://assets1.cleartax-cdn.com/cleartax/images/1645010711_eratio.svg',
    tooltip: `The price-to-earnings ratio (P/E ratio) is the ratio for valuing a company 
  that measures its current share price relative to its earnings per share 
  (EPS). The price-to-earnings ratio is also sometimes known as the price
   multiple or the earnings multiple.`,
  },
  {
    key: 'dividend_yield',
    placeholder: 'Dividend',
    pictureUrl:
      'https://assets1.cleartax-cdn.com/cleartax/images/1645010929_dividend.svg',
    tooltip: `A dividend is the distribution of some of a company's earnings to a class
  of its shareholders, as determined by the company's board of directors.`,
  },
  {
    key: 'roe',
    placeholder: 'ROE',
    pictureUrl:
      'https://assets1.cleartax-cdn.com/cleartax/images/1645010800_roe.svg',
    tooltip: `Return on equity (ROE) is a measure of financial performance calculated 
  by dividing net income by shareholders' equity.`,
  },
  {
    key: 'roce',
    placeholder: 'ROCE',
    pictureUrl:
      'https://assets1.cleartax-cdn.com/cleartax/images/1645010814_roce.svg',
    tooltip: `Return on capital employed (ROCE) is a financial ratio that can be used
  to assess a company's profitability and capital efficiency. In other words, 
 this ratio can help to understand how well a company is generating profits 
 from its capital as it is put to use.`,
  },
  {
    key: 'facevalue',
    placeholder: 'Face value',
    pictureUrl:
      'https://assets1.cleartax-cdn.com/cleartax/images/1645010823_facevalue.svg',
    tooltip: `Face value is a financial term used to describe the nominal or dollar value of a security, 
  as stated by its issuer. For stocks, the face value is the original cost of the stock, as 
  listed on the certificate.`,
  },
  {
    key: 'bookvalue',
    placeholder: 'Book value',
    pictureUrl:
      'https://assets1.cleartax-cdn.com/cleartax/images/1645010832_bookvalue.svg',
    tooltip: `The book value of a stock is theoretically the amount of money that would be paid to shareholders if the company was liquidated and paid off all of its liabilities. As a result, the book value equals the difference between a company's total assets and total liabilities.`,
  },
  {
    key: 'mcap',
    placeholder: 'Market capital',
    pictureUrl:
      'https://assets1.cleartax-cdn.com/cleartax/images/1645010697_marketcapital.svg',
    tooltip: `Market value (also known as OMV, or "open market valuation") is the
  price an asset would fetch in the marketplace, or the value that the 
 investment community gives to a particular equity or business.`,
  },
];

export type keyIndexPlaceHolderMappingType = Array<{
  key: string;
  placeholder: string;
  tooltip: string;
  pictureUrl: string;
}>;

export const keyIndexPlaceHolderMapping = [
  {
    key: 'today_high',
    placeholder: "Today's high",
    pictureUrl:
      'https://assets1.cleartax-cdn.com/cleartax/images/1663047078_equity.png',
    tooltip: `Today's high is the highest price at which a security, such as a stock, has traded after the market opened for the day.`,
  },
  {
    key: 'today_low',
    placeholder: "Today's low",
    pictureUrl:
      'https://assets1.cleartax-cdn.com/cleartax/images/1663046793_elss.png',
    tooltip: `Today's low is the lowest price at which a security, such as a stock, has traded after the market opened for the day.`,
  },
  {
    key: 'hi_52_wk',
    placeholder: '52w high',
    pictureUrl:
      'https://assets1.cleartax-cdn.com/cleartax/images/1663047136_govtdebt52whigh.png',
    tooltip:
      'The 52-week high is the highest price at which a security, such as a stock, has traded during the time period that equates to one year.',
  },
  {
    key: 'lo_52_wk',
    placeholder: '52w low',
    pictureUrl:
      'https://assets1.cleartax-cdn.com/cleartax/images/1663047155_liquid52wlow.png',
    tooltip:
      'The 52-week low is the lowest price at which a security, such as a stock, has traded during the time period that equates to one year.',
  },
];

export const SHAREHOLDERS = {
  buttonGroup: [
    { key: 'March', placeholder: 'Mar' },
    { key: 'June', placeholder: 'Jun' },
    { key: 'September', placeholder: 'Sep' },
    { key: 'December', placeholder: 'Dec' },
  ],
  title: 'What is shareholding pattern? Who are shareholders?',
  pictureUrl:
    'https://assets1.cleartax-cdn.com/cleartax/images/1645600094_group18142063.png',
  text1:
    'Shareholding pattern represents the percentage of share ownership that different investors are holding in the company. A company can have multiple investors who invest in its shares. These are called as shareholders and there are two major categories of shareholders - promoters and public shareholders.',
  text2:
    'Promoters are typically the founders and public shareholders could be financial institutes like banks, insurance companies, domestic institutional investors, foreign institutional investors and common public.',
};

export const TAB_LAYOUT = [
  { key: 'Overview', placeholder: 'Overview', id: 'overview' },
  { key: 'Share', placeholder: 'Financials', id: 'financials' },
  { key: 'Ratios', placeholder: 'Ratios', id: 'ratios' },
  { key: 'Peers', placeholder: 'Comparison', id: 'comparison' },
  {
    key: 'DividendsBonus',
    placeholder: 'Dividends & Bonuses',
    id: 'dividend',
  },
  { key: 'News', placeholder: 'News', id: 'news' },
  { key: 'About', placeholder: 'About', id: 'about' },
];

export const TAB_INDEX_LAYOUT = [
  { key: 'Overview', placeholder: 'Overview', id: 'overview' },
  { key: 'Companies', placeholder: 'Companies', id: 'companies' },
  { key: 'News', placeholder: 'News', id: 'news' },
  { key: 'About', placeholder: 'About', id: 'about' },
  { key: 'All Indices', placeholder: 'All Indices', id: 'allIndices' },
];

export const TAB_GOLD_SILVER = [
  {
    key: 'gold',
    placeholder: 'Gold Rates',
    id: 'gold-rate',
  },
  {
    key: 'silver',
    placeholder: 'Silver Rates',
    id: 'silver-rate',
  },
];

export const NEWS_IMAGES = [
  'https://assets1.cleartax-cdn.com/cleartax/images/1646282942_gettyimages11614716041d63e4729306bc93c98f75df6fdf515425f7a9354s1100c50.jpeg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1646282953_buy_sell_660_040221093629.jpeg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1646282968_images.jpeg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1646283056_stocksinthenewstatamotorsntpcgreavescottonndmcandautos.jpeg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1646283065_stocks_sensex_nifty_stockmarket3.jpeg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1646283074_stocks_sensex_nifty_stockmarket3.jpeg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1646283083_1069721681639684854675abny2.jpeg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1646283090_gettystockmarketrising.jpeg',
  'https://assets1.cleartax-cdn.com/tax-library/images/1646199349_960x0.jpeg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1646735380_stock5.webp',
  'https://assets1.cleartax-cdn.com/cleartax/images/1646735366_stock3.jpeg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1646735360_istockphoto943292690612x612.jpeg',
];

export type WEBPAGE_SCHEMA_TYPE = {
  title: string;
  metaDesc: string;
  url: string;
};

export const WEB_SCHEMA = ({
  title,
  metaDesc,
  url,
}: WEBPAGE_SCHEMA_TYPE): unknown => {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    'name': title,
    'description': metaDesc,
    'url': url,
    'publisher': {
      '@type': 'Organization',
      'name': 'ClearTax',
      'url': 'https://cleartax.in/',
      'logo': {
        '@type': 'ImageObject',
        'contentUrl':
          'https://assets1.cleartax-cdn.com/cleartax/images/1642742112_logosvg.svg',
      },
    },
  };
};

export const getBreadCrumbSchema = (
  BreadcrumbsData: BREADCRUMB_TYPE[]
): unknown => {
  const itemList: Array<{
    '@type': string;
    'position': number;
    'item': {
      '@id': string;
      'name': string;
    };
  }> = [];

  BreadcrumbsData.map((item, idx) => {
    itemList.push({
      '@type': 'ListItem',
      'position': idx + 1,
      'item': {
        '@id': `${item.link ? item.link : ''}`,
        'name': `${item.title}`,
      },
    });
  });
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [...itemList],
  };
};
